export interface UserHeadEntity {
    id : string;
    headPicPath : string;
    needWatchAdFlag : boolean;
}

/**
 * 用户头像配置
 * @constructor
 */
export function UserHeadConfig() {
    const dataArray : UserHeadEntity[] = [
        {
            id : "1",
            headPicPath : "default",
            needWatchAdFlag : false,
        },
        {
            id : "2",
            headPicPath : "012",
            needWatchAdFlag : true,
        },
        {
            id : "3",
            headPicPath : "002",
            needWatchAdFlag : true,
        },
        {
            id : "4",
            headPicPath : "003",
            needWatchAdFlag : true,
        },
        {
            id : "5",
            headPicPath : "004",
            needWatchAdFlag : true,
        },
        {
            id : "6",
            headPicPath : "013",
            needWatchAdFlag : true,
        },
        {
            id : "7",
            headPicPath : "006",
            needWatchAdFlag : true,
        },
        {
            id : "8",
            headPicPath : "014",
            needWatchAdFlag : true,
        },
        {
            id : "9",
            headPicPath : "008",
            needWatchAdFlag : true,
        },
        {
            id : "10",
            headPicPath : "009",
            needWatchAdFlag : true,
        },
        {
            id : "11",
            headPicPath : "010",
            needWatchAdFlag : true,
        },
        {
            id : "12",
            headPicPath : "015",
            needWatchAdFlag : true,
        },
    ];
    return dataArray;
}

export function getOneHeadUrlById(id:string){
    // console.log(id,"??????????")
    let ary = UserHeadConfig();
    for(let k of ary){
        if(k.id == id){
            return k.headPicPath;
        }
    }
}
